import { EventType, PublicClientApplication } from "@azure/msal-browser";
import { msalConfig } from "./authConfig";
import { logActivity } from "../api/activityLog";

export const msalInstance = new PublicClientApplication(msalConfig);

// Only log the interactive login once per session, not every silent token
// refresh — ACQUIRE_TOKEN_SUCCESS fires constantly as access tokens renew,
// and we only care about an actual sign-in event here.
let loggedThisSession = false;

msalInstance.addEventCallback((event) => {
  if (
    (event.eventType === EventType.LOGIN_SUCCESS ||
      event.eventType === EventType.ACQUIRE_TOKEN_SUCCESS) &&
    event.payload &&
    "account" in event.payload &&
    event.payload.account
  ) {
    msalInstance.setActiveAccount(event.payload.account);
  }

  if (event.eventType === EventType.LOGIN_SUCCESS && !loggedThisSession) {
    loggedThisSession = true;
    const name = (event.payload && "account" in event.payload && event.payload.account?.name) || "Someone";
    void logActivity("Auth", "Login", `${name} signed in`);
  }
});
